import React, { useCallback, useState } from "react";
import { Col, Form, Input, Modal, Row, Select } from "antd";
import { EditDocumentIcon } from "../../../resource/icons";
import { dspxGetChildrens } from "../../../helpers/dspx-utils";
import ContactorRadioButton from "../ContractorRadioButton/ContractorRadioButton";
import { useDispatch } from "react-redux";

import actions from "../store/actions/edit-document.actions";
import ContractorRef from "../../../components/contractor-ref";

const EditContractorModal = ({
	visible,
	onCancel,
	contractorsList,
	fprops,
	form,
}) => {
	const dispatch = useDispatch();
	const subject = "Адресат";
	const [contractorType, setContractorType] = useState();
	const [clientName, setClientName] = useState();
	const [orgId, setOrgId] = useState();
	const onOk = useCallback(() => {
		if (contractorType === "fio_data") {
			dispatch(actions.addClient(fprops.id, clientName));
		}
		if (contractorType === "org_data") {
			const org = contractorsList.find((contactor) => +contactor.id === +orgId);
			dispatch(actions.addOrgToDoc(fprops.id, orgId, org.inn));
		}
		dispatch(actions.closeModal());
	}, [contractorType, fprops.id, fprops.editClient?.id, clientName, orgId]);
	return (
		<Modal
			style={{ minWidth: 350 }}
			width={350}
			visible={visible}
			title={
				<span>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					{subject}
				</span>
			}
			okText="Добавить"
			onCancel={() => {
				setContractorType();
				setClientName();
				setOrgId();
				onCancel();
			}}
			onOk={onOk}
			okButtonProps={{
				disabled: contractorType === "org_data" ? !orgId : !clientName,
			}}
		>
			<Form layout="vertical">
				<Row gutter={8}>
					<Col span={24}>
						<Form.Item label={"Контрагент"}>
							<ContactorRadioButton
								value={contractorType}
								onChange={(e) => setContractorType(e.target.value)}
							/>
						</Form.Item>
						{contractorType === "org_data" && (<>
							<Form.Item label={subject}>
								<Select
									showSearch
									placeholder="организация"
									notFoundContent="нет данных"
									optionFilterProp="searchtext"
									onChange={(value) => {
										setOrgId(value);
									}}
									value={orgId}
								>
									{dspxGetChildrens(contractorsList)}
								</Select>
							</Form.Item>
							<ContractorRef
								reftype="document"
								searchInnUrl={'/Docs/orgs_by_inn'}
								addCreatedOrg={(createdOrgId) => {
									const keys = form.getFieldValue('keys');
									for (const key of keys) {
										if (!form.getFieldValue(`orgId[${key}]`)) {
											form.setFieldsValue({
												[`orgId[${key}]`]: `${createdOrgId}`,
											});
											break;
										}
									}
								}}
							/>
						</>)}
						{contractorType === "fio_data" && (
							<Form.Item label={subject}>
								<Input
									placeholder="Имя клиента"
									onChange={(e) => setClientName(e.target.value)}
									value={clientName}
								/>
							</Form.Item>
						)}
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default EditContractorModal;
